import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const LANGUAGE_STORAGE_KEY = 'i18nLanguage';

const savedLanguage = (() => {
    try {
        return localStorage.getItem(LANGUAGE_STORAGE_KEY);
    } catch (error) {
        return null;
    }
})();

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    // Start in the saved language so Arabic visitors don't see English first.
    lng: savedLanguage === 'ar' ? 'ar' : 'en',
    supportedLngs: ['en', 'ar'],
    resources: {
        en: { site: require('./locales/en/site.json') },
        ar: { site: require('./locales/ar/site.json') }
    },
    ns: ['site'],
    defaultNS: 'site',
    interpolation: { escapeValue: false }
});

export default i18n;
